module.exports = __webpack_public_path__ + "assets/img/desktron-banner.929093cc.svg";